import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import "./AuthModal.scss";

function AuthModal({ isOpen, onClose, initialView = "login", onAuthSuccess }) {
  const [currentView, setCurrentView] = useState(initialView);
  const { isAuthenticated, resetEmailSent } = useSelector((state) => state.auth);

  // Log mount and initial props
  useEffect(() => {
    console.log('[AuthModal] Mounted with props:', {
      isOpen,
      initialView,
      hasAuthSuccessCallback: !!onAuthSuccess
    });
  }, []);

  // Log when view changes
  useEffect(() => {
    console.log('[AuthModal] View changed to:', currentView);
  }, [currentView]);

  // When user gets authenticated, call onAuthSuccess instead of just closing
  useEffect(() => {
    console.log('[AuthModal] Auth state changed. isAuthenticated:', isAuthenticated);
    if (isAuthenticated && isOpen) {
      console.log('[AuthModal] User authenticated, calling onAuthSuccess and closing modal');
      if (onAuthSuccess) {
        onAuthSuccess();
      }
      onClose();
    }
  }, [isAuthenticated, isOpen, onClose, onAuthSuccess]);
  
  // Monitor reset email status
  useEffect(() => {
    console.log('[AuthModal] Reset email status changed:', resetEmailSent);
  }, [resetEmailSent]);

  if (!isOpen) {
    return null;
  }

  const handleRegisterClick = () => {
    console.log('[AuthModal] Register button clicked, switching to register view');
    setCurrentView("register");
  };

  const handleLoginClick = () => {
    console.log('[AuthModal] Login button clicked, switching to login view');
    setCurrentView("login");
  };
  
  const handleForgotPasswordClick = () => {
    console.log('[AuthModal] Forgot password button clicked, switching to forgot password view');
    setCurrentView("forgotPassword");
  };

  const renderForm = () => {
    console.log('[AuthModal] Rendering form for view:', currentView);
    switch (currentView) {
      case "register":
        return <RegisterForm onLoginClick={handleLoginClick} />;
      case "forgotPassword":
        return <ForgotPasswordForm onLoginClick={handleLoginClick} />;
      case "login":
      default:
        return (
          <LoginForm 
            onRegisterClick={handleRegisterClick} 
            onForgotPasswordClick={handleForgotPasswordClick} 
          />
        );
    }
  };

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal">
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        
        {renderForm()}
      </div>
    </div>
  );
}

export default AuthModal;
